import { Alert, Box, Chip, Divider, Stack, TextField, Typography } from '@mui/material';
import InventoryChoice from './InventoryChoice';
import SetupSection from './SetupSection';
import { Icon, IconSize } from '@shared/icons';

interface InventoryStepProps {
  description: string;
  choiceCaption: string;
  loadInventory: boolean | null;
  onLoadInventoryChange: (value: boolean) => void;
  warehouses: { id: string; name: string }[];
  warehouseName: string;
  warehouseLocation: string;
  onWarehouseNameChange: (value: string) => void;
  onWarehouseLocationChange: (value: string) => void;
}

const InventoryStep = ({
  description,
  choiceCaption,
  loadInventory,
  onLoadInventoryChange,
  warehouses,
  warehouseName,
  warehouseLocation,
  onWarehouseNameChange,
  onWarehouseLocationChange,
}: InventoryStepProps) => (
  <Stack spacing={0}>
    <SetupSection title="Sync inventory" description={description}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <InventoryChoice selected={loadInventory === true} title="Import" caption={choiceCaption} onClick={() => onLoadInventoryChange(true)} />
        <InventoryChoice selected={loadInventory === false} title="Don't import" caption={choiceCaption} onClick={() => onLoadInventoryChange(false)} />
      </Stack>

      {warehouses.length > 0 && (
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            You already have {warehouses.length} {warehouses.length === 1 ? 'warehouse' : 'warehouses'}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {warehouses.map(warehouse => (
              <Chip key={warehouse.id} label={warehouse.name} size="small" color="info" />
            ))}
          </Stack>
        </Stack>
      )}
    </SetupSection>


    {loadInventory !== null && (
      <>


        {loadInventory ? (
          <>
            <Divider />

            <SetupSection title="Your new warehouse">
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField size="small" fullWidth label="Name" value={warehouseName} onChange={event => onWarehouseNameChange(event.target.value)} />
                <TextField size="small" fullWidth label="Location (optional)" value={warehouseLocation} onChange={event => onWarehouseLocationChange(event.target.value)} />
              </Stack>
            </SetupSection>
          </>
        ) : (

          <Box sx={{ p: 0 }}>
            <Alert severity="warning" sx={{ px: 4, py: 2 }} icon={<Icon icon="AlertCircle" size={IconSize.MEDIUM} />}>
              We won't import your inventory from {warehouseName}
            </Alert>
          </Box>
        )}
      </>
    )}
  </Stack>
);

export default InventoryStep;
